import React from 'react';

const Hero: React.FC = () => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[radial-gradient(ellipse_90%_80%_at_50%_50%,#1c1c1c_0%,#0a0a0a_100%)]"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute top-[15%] left-[-5%] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(184,184,184,0.06)_0%,transparent_70%)] animate-orb-float pointer-events-none"></div>
      <div className="absolute bottom-[8%] right-[-10%] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(201,169,110,0.05)_0%,transparent_70%)] animate-orb-float pointer-events-none" style={{ animationDirection: 'reverse' }}></div>

      <div className="relative z-10 text-center px-6 max-w-[860px]">
        <div className="inline-block text-[10px] tracking-[4px] uppercase text-gold border border-gold/30 px-5 py-2 mb-11 animate-fade-up delay-1">
          Mode Masculine · Depuis 2020
        </div>

        <h1>
          <span className="block font-serif text-[clamp(90px,16vw,172px)] font-bold tracking-[0.15em] text-white leading-[0.88] animate-fade-up delay-2">
            GERAK
          </span>
          <span className="block font-serif text-[clamp(18px,3vw,30px)] font-light italic tracking-[0.35em] text-silver mt-3 mb-9 animate-fade-up delay-3">
            Fashion & Classic
          </span>
        </h1>

        <p className="text-[clamp(13px,1.8vw,16px)] text-silver leading-7 max-w-[520px] mx-auto mb-12 tracking-wider animate-fade-up delay-3">
          L'élégance masculine réinventée. Des vêtements qui parlent sans un mot — taillés pour l'homme moderne qui sait qui il est.
        </p>

        <div className="flex gap-4 justify-center flex-wrap animate-fade-up delay-4">
          <button
            onClick={() => scrollTo('collections')}
            className="bg-white text-black border-none px-10 py-4 text-[10px] tracking-[3px] uppercase font-semibold transition-all hover:bg-gold hover:-translate-y-1"
          >
            Découvrir les Collections
          </button>
          <button
            onClick={() => scrollTo('univers')}
            className="bg-transparent text-white border border-mid px-10 py-4 text-[10px] tracking-[3px] uppercase font-medium transition-all hover:border-silver hover:-translate-y-1"
          >
            Notre Univers
          </button>
        </div>
      </div>

      <div className="absolute bottom-9 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 z-10">
        <span className="text-[8px] tracking-[4px] uppercase text-mid">Scroll</span>
        <div className="w-px h-[50px] bg-gradient-to-b from-transparent to-mid relative overflow-hidden">
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-silver animate-scroll-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;